import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { throttle } from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import { getTblProductsSearch } from "../services/TblProductsServices";

const TblProductsSearch = ({
  searchValue,
  onProductSelected,
  onProductFound,
}) => {
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [errorText, setErrorText] = useState("");
  const [selectionError, setSelectionError] = useState("");

  useEffect(() => {
    if (searchValue) {
      setValue({ productCode: searchValue });
      setInputValue(searchValue);
    } else {
      setValue(null);
      setInputValue("");
    }
  }, [searchValue]);

  useEffect(() => {
    if (!inputValue || inputValue.length <= 2) {
      setErrorText("");
      setOptions([]);
    }
  }, [inputValue]);

  const fetch = useMemo(
    () =>
      throttle((request) => {
        if (request?.input.length > 2) {
          getTblProductsSearch(request.input)
            .then((res) => {
              const products = res.data || [];

              if (products.length === 0) {
                setOptions([]);
                setErrorText("Product not found");
                setSelectionError("");
                onProductFound?.(false);
              } else {
                setOptions(products);
                setErrorText("");
                onProductFound?.(true);
              }
            })
            .catch((err) => {
              console.error(err);
              setOptions([]);
              onProductFound?.(false);
            });
        }
      }, 200),
    []
  );

  useEffect(() => {
    if (!inputValue || inputValue.length <= 2) return;
    fetch({ input: inputValue });
  }, [inputValue, fetch]);
  return (
    <Autocomplete
      id="tbl-products-search"
      onBlur={() => {
        if (options.length > 0 && !value && inputValue.length > 2) {
          setSelectionError(
            "Please select a plan from the search results to continue."
          );
        }
      }}
      freeSolo
      sx={{ width: 250 }}
      options={options}
      value={value}
      inputValue={inputValue}
      onInputChange={(event, newInputValue, reason) => {
        setInputValue(newInputValue);
        setSelectionError("");

        if (reason === "input") {
          setValue(null);
          onProductSelected?.(null); // Disable Save/Submit
        }

        if (!newInputValue) {
          setOptions([]);
          setErrorText("");
        }
      }}
      onChange={(event, newValue) => {

        setValue(newValue);

        if (newValue) {
          setInputValue(newValue);
          setSelectionError("");
          onProductSelected?.(newValue); // Enable Save/Submit
        } else {
          onProductSelected?.(null);
        }
      }}
      getOptionLabel={(option) => option?.productCode || ""}
      isOptionEqualToValue={(option, value) =>
        option.productCode === value.productCode
      }
      noOptionsText="No Plan Id Found"
      filterOptions={(x) => x}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Plan Id Search"
          error={!!errorText || !!selectionError}
          helperText={errorText || selectionError}
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.id}>
          <Stack direction="column">
            <p>Plan Id : {option.productCode}</p>
          </Stack>
        </Box>
      )}
    />
  );
};

export default TblProductsSearch;